import React, { createContext, useState, useEffect, useContext } from 'react';

import axios from './utils/axios';

const TournamentContext = createContext();

export const TournamentProvider = ({ children }) => {

    const [ loading, setLoading ] = useState(true);
    const [ tournament, setTournament ] = useState({})

    const [ coaches, setCoaches ] = useState([])

    const [ updatedAt, setUpdatedAt ] = useState(new Date())

    const path = window.location.pathname;
    const id_tournament = path.split('/')[2];

    useEffect(() => {
        if(!id_tournament){
            return
        }

        axios.get(apiURL(`tournaments/${id_tournament}`)).then(payload => {
            setTournament(payload?.data)
        })

        axios.get(apiURL(`tournaments/${id_tournament}/coaches`)).then(payload => {
            setCoaches(payload?.data)
        })

    }, [id_tournament, updatedAt])

    const apiURL = url => {
        return `${process.env.REACT_APP_API}/api/documents/${url}`
    }

    window.addEventListener("inua-refresh", function(event) {
        setUpdatedAt(new Date())
    });

    const value = {
        tournament, loading, apiURL, coaches,
    };

    return <TournamentContext.Provider value={value}>{children}</TournamentContext.Provider>;
};

export const useTournamentContext = () => useContext(TournamentContext);
